import React from 'react';
import BeforeYouUpdateModal from './BeforeYouUpdateModal';
import NotificationPanel from './NotificationPanel';
import ScheduleUpdateModal from './ScheduleUpdateModal';
import UpdateInProgressCard from './UpdateInProgressCard';
import UpdatePopup from './UpdatePopup';
import WhatsNewModal from './WhatsNewModal';
import '../styles/platformUpgrader.css';

/** The update popup, the in-progress card, the bell's panel and the modals, all driven by one ``upgrader`` state. */
export default function PlatformUpgrader({ upgrader }) {
    if (!upgrader.active) return null;
    return (
        <>
            <UpdatePopup upgrader={upgrader} />
            {upgrader.upgrade && (
                <UpdateInProgressCard
                    upgrade={upgrader.upgrade}
                    isAdmin={upgrader.isAdmin}
                    onShowWaitingFor={upgrader.showWaitingFor}
                    onCancel={upgrader.cancelUpdate}
                />
            )}
            <NotificationPanel upgrader={upgrader} />
            <BeforeYouUpdateModal
                open={upgrader.modal === 'before' || upgrader.modal === 'waiting'}
                waiting={upgrader.modal === 'waiting'}
                busy={upgrader.busy}
                onClose={upgrader.closeModal}
                onUpdateNow={upgrader.updateNow}
                onUpdateAnyway={upgrader.updateAnyway}
                onScheduleLater={upgrader.openSchedule}
                onCancel={upgrader.cancelUpdate}
            />
            <ScheduleUpdateModal
                open={upgrader.modal === 'schedule'}
                scheduleWindow={upgrader.scheduleWindow}
                onClose={upgrader.closeModal}
                onSchedule={upgrader.scheduleUpgrade}
            />
            <WhatsNewModal
                open={upgrader.modal === 'whats-new'}
                releases={upgrader.whatsNew}
                onClose={upgrader.closeWhatsNew}
            />
        </>
    );
}
